import { useMutation, useQuery } from "@tanstack/react-query";
import { onboardingService } from "../services/onboarding.service";
import { useAuth } from "../context/AuthContext";

/**
 * GET /auth/onboarding/prefill
 * Validates the chat link's token and returns safe prefill data
 * (name, country, currency, masked phone) for the Finish Setup page.
 */
export function useOnboardingPrefill(token) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["onboarding", "prefill", token],
    queryFn: () => onboardingService.getPrefill(token),
    enabled: Boolean(token),
    retry: false,
  });

  return {
    prefill: data,
    isLoadingPrefill: isLoading,
    isPrefillError: isError,
    prefillError: error,
  };
}

/**
 * POST /auth/onboarding/complete
 * Creates the account (with password) for a WhatsApp-initiated signup.
 * Same shape as useAuthMutations().signup: pushes the returned user into
 * AuthContext on success so the app treats them as logged in immediately.
 */
export function useCompleteOnboarding() {
  const { setUser } = useAuth();

  const mutation = useMutation({
    mutationFn: onboardingService.complete,
    onSuccess: (data) => setUser(data.user),
  });

  return {
    completeOnboarding: mutation.mutate,
    completeOnboardingAsync: mutation.mutateAsync,
    isCompleting: mutation.isPending,
    completeError: mutation.error,
  };
}
